export default function Logo() {
  return (
    <div className="flex items-center space-x-3">
      <img 
        src="/Design ohne Titel-16.png" 
        alt="ImmoIQ Logo" 
        className="h-12 w-auto"
      />
      <span className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
        ImmoIQ
      </span>
    </div>
  );
}